if (!customElements.get('inxiz-menu-groups')) {
  customElements.define('inxiz-menu-groups', class extends HTMLElement {
    connectedCallback() {
      const drawer = this.closest('navigation-drawer');
      if (!drawer) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const trigger = drawer.querySelector(`[data-inxiz-group-toggle="${CSS.escape(this.dataset.blockId)}"]`);
      const wrapper = this.closest('.panel__wrapper');
      const back = wrapper.querySelector('button[data-panel="0"]');
      if (!trigger || !back) return;
      const focusAfterTransition = (target, panel) => requestAnimationFrame(async () => {
        await Promise.allSettled(panel.getAnimations({subtree: true}).map(animation => animation.finished));
        if (drawer.hasAttribute('open') && target.checkVisibility()) target.focus({preventScroll: true});
      });
      drawer.addEventListener('click', event => {
        const button = event.target.closest('button[data-panel]');
        if (button === trigger) {
          trigger.setAttribute('aria-expanded', 'true');
          focusAfterTransition(back, wrapper.closest('.panel'));
        } else if (button === back) {
          trigger.setAttribute('aria-expanded', 'false');
          focusAfterTransition(trigger, trigger.closest('.panel'));
        }
      }, {signal});
      drawer.addEventListener('dialog:after-hide', () => trigger.setAttribute('aria-expanded', 'false'), {signal});
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
